module.exports = __webpack_public_path__ + "static/media/4_place.3c555e74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/4_place.svg
// module id = 2172
// module chunks = 0